import React, {
    useState, useEffect, useCallback, useContext, useMemo
} from 'react';
import _ from 'lodash';
import { Link } from 'gw-components-platform-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import { useAuthentication } from 'gw-digital-auth-react';
import {
    Loader, DateValue
} from '@jutro/components';

import { BreakpointTrackerContext, withBreakpoint } from '@jutro/layout';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import styles from './LandingPage.module.scss';
import { getMetadataByBreakPoint } from '../../customer/utils/breakpointUtil';

const dueDateCell = (serviceRequestCell) => {
    const { dueDate } = serviceRequestCell;
    if (dueDate === undefined) {
        return '';
    }

    // return <FormattedDate value={new Date(dueDate)} format="short" />;

    return (
        <DateValue
            format="short"
            placeholder="-"
            showTime={false}
            value={dueDate}
        />
    );
};

const serviceTypeCell = ({ services }) => {
    if (typeof services === 'undefined') {
        return '';
    }
    return services.join(', ');
};

const searchTableFilter = (filterValue) => (row) => {
    const val = filterValue.toLowerCase();
    return (
        row.customerContact.toLowerCase().includes(val)
            || row.claimID.toLowerCase().includes(val)
            || row.services.some((item) => item.toLowerCase().includes(val))
    );
};

function LandingPage() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [serviceRequestData, setServiceRequestData] = useState([]);
    const [quoteRequestData, setQuoteRequestData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const breakpoint = useContext(BreakpointTrackerContext);

    const filterServiceItems = useCallback((serviceItems) => {
        // second condition checks if request has a approved quote attached to it
        // if that's the case then move the request to service requests category
        const serviceRequests = serviceItems.filter((item) => item.requestKind === 'serviceonly'
            || (item.requestKind === 'quoteandservice' && (item.nextStepCode === 'FinishWork' || item.nextStepCode === 'FollowUp_WorkOverdue')));
        const quoteRequests = serviceItems.filter((item) => item.requestKind === 'quoteonly'
            || (item.requestKind === 'quoteandservice' && (item.nextStepCode !== 'FinishWork' && item.nextStepCode !== 'FollowUp_WorkOverdue')));
        setQuoteRequestData(quoteRequests);
        setServiceRequestData(serviceRequests);
    }, []);

    useEffect(() => {
        setLoadingState(true);
        ServiceRequestService.getServiceRequestsForVendor(authHeader).then(
            filterServiceItems
        ).finally(() => {
            setLoadingState(false);
        });
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const statesForOperation = useMemo(() => {
        return {
            specialistacceptedwork: translator(messages.serviceRequestProgressAcceptWork),
            specialistdeclined: translator(messages.serviceRequestProgressDeclineWork),
            specialistcompletedwork: translator(messages.serviceRequestProgressCompleteWork),
            specialistcanceled: translator(messages.serviceRequestProgressCancelWork),
            addinvoice: translator(messages.serviceRequestProgressAddInvoice),
            specialistresumedwork: translator(messages.serviceRequestProgressResumeWork),
            addquote: translator(messages.serviceRequestProgressAddQuote)
        };
    }, [translator]);

    const progressCell = useCallback(({
        defaultOperation, status, requestKind, nextStepCode
    }) => {
        if (!_.isEmpty(defaultOperation)) {
            if (nextStepCode === 'FollowUp_WorkOverdue' && defaultOperation === 'specialistcompletedwork' && status === 'inprogress') {
                return translator({
                    id: `typekey.ServiceRequestProgress.${status}`,
                    defaultMessage: ''
                });
            }
            return _.get(statesForOperation, defaultOperation, '');
        }
        if (requestKind === 'quoteonly'
            || (requestKind === 'quoteandservice' && nextStepCode !== 'FinishWork')) {
            return translator({
                id: `typekey.ServiceRequestProgress.${status}`,
                defaultMessage: ''
            });
        }
        return '';
    }, [statesForOperation]);

    const nameCell = useCallback(({ customerContact, serviceRequestNumber }) => {
        return (
            <Link to={`/service-request-details/${serviceRequestNumber}`}>
                {customerContact}
            </Link>
        );
    }, []);

    const getTableOverrides = useCallback(() => {
        return {
            serviceTypeColumn: { onCell: serviceTypeCell },
            dueDateColumn: { onCell: dueDateCell },
            progressColumn: { onCell: progressCell },
            nameColumn: { onCell: nameCell },
        };
    }, [nameCell, progressCell]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const override = {
        '@field': {
            labelPosition: 'left'
        },
        serviceRequestsTable: {
            data: serviceRequestData,
            filter: searchTableFilter
        },
        quoteRequestsTable: {
            data: quoteRequestData,
            filter: searchTableFilter
        },
        ...getTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return renderContentFromMetadata(getMetadataByBreakPoint(metadata, breakpoint), override, resolvers);
}

 export default withRouter(LandingPage);
//export default withBreakpoint(withRouter(LandingPage));
